// import css
import '../styles/global.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import TaichiHeader from './components/header';
import TaichiFooter from './components/footer';
import Fade from './components/fade';
import CommonApp from './_commonApp';
import PageHader from './components/page-header';
import FloatNavigation from './components/float-navigation';

const NavigationOverlay = React.lazy(() => import('./components/navigation-overlay'))
const BlogContent = React.lazy(() => import('./components/blog-content'))
const BlogNav = React.lazy(() => import('./components/blog-nav'))
const BlogNavigation = React.lazy(() => import('./components/blog-navigation'))

class App extends CommonApp {

    constructor(props) {
        super(props);
        this.closeNav = this.closeNav.bind(this)
        this.openNav = this.openNav.bind(this)
        this.state = {
            openOverlay: false,
            post: {},
            categories: [],
        }
    }

    componentDidMount() {
        this.checkAvailableImageFormat();
        this.getPost();
    }

    getPost() {
        const slug = window.location.pathname.replace(/\//g, '')
        const url = "/wp-json/wp/v2/posts?slug=" + slug + "&per_page=1"
        fetch(url).then(res => res.json()).then(data => {
            if(data.length) {

                fetch('/wp-json/wp/v2/categories?post=' + data[0].id + "&orderby=id").then(res => res.json()).then(categoriesData => {
                    this.setState({
                        post: data[0],
                        categories: categoriesData
                    })
                })
            }
        })
    }


    render() {
        return (
            <div id='wrapper' className='font-default-sans pt-[6rem] lg:pt-0'>
                <TaichiHeader openNav={this.openNav} active="blog"></TaichiHeader>
                <div id='article-wrapper' className='max-w-6xl mx-auto pb-20 px-4'>
                    <PageHader text="blog" subText="ブログ"></PageHader>
                    <div className='lg:grid grid-cols-[1fr_290px] px-4 w-full'>
                        <div>
                            <BlogContent post={this.state.post} categories={this.state.categories} large></BlogContent>
                            <BlogNavigation 
                                next={this.state.post && this.state.post.previous && "/" + this.state.post.previous.slug}
                                prev={this.state.post && this.state.post.next && '/' + this.state.post.next.slug}
                                list="/blogs"
                            ></BlogNavigation>
                        </div>
                        <BlogNav></BlogNav>
                    </div>

                </div>
                <TaichiFooter></TaichiFooter>
                <Fade openOverlay={this.state.openOverlay} exClass='fixed w-screen h-screen top-0 lg:hidden left-full z-50'>
                    <NavigationOverlay closeNav={this.closeNav}></NavigationOverlay>
                </Fade>
                <FloatNavigation></FloatNavigation>
            </div>
        );
    }
    

};

const root = createRoot(document.getElementById('app'));
root.render(<App />)